module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_0.63d04ded.png";